import { useMediaQuery } from '@mui/material';

interface IBudgetAddServiceButtonsProps {
  onAddNewService: () => void;
  onAddExternalService: () => void;
}

const BudgetAddServiceButtons = (props: IBudgetAddServiceButtonsProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  return (
    <div className={isMobile ? 'px-2' : 'px-6'}>
      <button
        type="button"
        className={`btn btn-default ${isMobile ? 'm-2 ml-0 w-full' : 'm-4 ml-0'}`}
        onClick={props.onAddNewService}
      >
        <img
          src="/assets/images/plusGreen.svg"
          alt="Van"
          className="w-5 h-5 flex-shrink-0 mx-2"
        />
        <span className={isMobile ? 'text-size-14' : ''}>Adicionar novo serviço ao orçamento</span>
      </button>

      <button
        type="button"
        className={`btn text-gray-500 dark:text-neutral-400 border-gray-200 dark:border-neutral-700 border rounded-md ${isMobile ? 'm-2 w-full' : 'm-4'}`}
        onClick={props.onAddExternalService}
      >
        <img src="/assets/images/plus.svg" alt="Van" className="w-5 h-5 flex-shrink-0 mx-2 dark:invert" />
        <span className={isMobile ? 'text-size-14' : ''}>Adicionar serviço adicional / externo</span>
      </button>
    </div>
  );
};

export default BudgetAddServiceButtons;

